export default [
  {
    title: 'Bienvenido',
    element: 'body',
    text: 'Bienvenido a Idonia, tu plataforma de intercambio de imágenes. En este tour te ayudaremos a empezar a utilizarla.'
  },
  {
    title: 'Mi Espacio',
    element: '.idonia-header .toolbar__title',
    text: 'En "Mi Espacio" podrás ver todas las carpetas, documentos y estudios que tengas en Idonia.'
  },
  {
    title: 'Botón "+"',
    element: '.action-fab button',
    text: 'Utiliza este menú para crear una carpeta de contenidos, subir un archivo o carpetas de tu dispositivo.',
    clickNext: 'nav button',
    wait: 150,
    placement: {
      relativeTo: 'viewport',
      position: 'top'
    }
  },
  {
    title: 'Archivos Compartidos',
    element: 'a[data-name="shared"]',
    text: 'En "compartido conmigo" podrás ver los casos que la SERAM ha compartido contigo así como otros archivos y carpetas compartidos por otros usuarios.',
    clickBack: 'nav button',
    wait: 150
  }
]



// WEBPACK FOOTER //
// ./src/components/common/tour/tours/mobile/es-ES/seram2018.js